import { render, staticRenderFns } from "./SalaryItem.vue?vue&type=template&id=2f2015fa&scoped=true"
import script from "./SalaryItem.vue?vue&type=script&lang=js"
export * from "./SalaryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2015fa",
  null
  
)

export default component.exports